import type { RouteQuery } from '#graphql-operations'
import { notNullish } from '@vueuse/core'
import { getPathFromUrl } from '~/helpers'
import { LANGUAGE_LABEL } from '~/helpers/locale'

type LanguageLink = {
  code: string
  path: string
  label: string
  active: boolean
}

type UseDrupalLanguageLinks = {
  setLanguageLinks: (query?: RouteQuery | undefined | null) => void
  links: ComputedRef<LanguageLink[]>
}

export function useDrupalLanguageLinks(): UseDrupalLanguageLinks {
  const routeLinks = useState<Omit<LanguageLink, 'active'>[]>(
    'drupalLanguageLinks',
    () => [],
  )
  const language = useCurrentLanguage()

  function setLanguageLinks(query?: RouteQuery | undefined | null) {
    if (query && query.route && 'languageSwitchLinks' in query.route) {
      routeLinks.value = query.route.languageSwitchLinks
        .map((v) => {
          if (v.url.path && v.title && v.language.id) {
            const code = v.language.id
            return {
              code,
              path: getPathFromUrl(v.url.path),
              label: LANGUAGE_LABEL[code] || code,
            }
          }

          return null
        })
        .filter(notNullish)
    }
  }

  const links = computed(() =>
    routeLinks.value.map((link) => {
      return {
        ...link,
        active: link.code === language.value,
      }
    }),
  )

  return {
    setLanguageLinks,
    links,
  }
}
